import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import clsx from 'clsx';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { DealerBoothPublicDto } from '@furality/fox-client/models';
import FontAwesomeIcon from '@/components/FontAwesomeIcon.tsx';
import LinkButton from '@/components/LinkButton.tsx';

import style from './DealerLocationInfo.module.scss';

type DealerLocationProps = {
  dealer: DealerBoothPublicDto;
};

/**
 * This component is heavily based off WorldCard.
 * TODO make this a reusable component.
 */
const DealerLocationInfo: FC<DealerLocationProps> = ({ dealer }) => {
  const { t } = useTranslation();
  const { ownerDisplayLocation, ownerLocation, ownerDisplayName } = dealer;

  // Dealer needs a vrchat account to show location, and also be in the dealer's den AND have dealer visiblity toggled on.
  if (!ownerDisplayName || !ownerLocation || !ownerDisplayLocation) {
    return null;
  }

  return (
    <div
      className={clsx(
        'p-4 my-3 mb-4 align-middle justify-between',
        style['dealerLocationContainer'],
      )}
    >
      <span className="mr-3 text-success">
        <FontAwesomeIcon icon={faCircle} />
      </span>
      <span className="font-weight-bold">
        <strong>{ownerDisplayName}</strong>
      </span>
      <span> &nbsp; @ &nbsp; </span> {/** TODO i18n */}
      <span className="font-weight-bold text-white mr-3">{ownerLocation}</span>
      <span className="flex-grow-1"></span>
      {/** TODO make this join button actual send an invite */}
      <LinkButton
        to="/explore/event/$id"
        params={{ id: ownerLocation }}
        rounded
        variant="primary"
        className={clsx(style['dealerLocationInfo-btn'])}
      >
        {t('f7.shared.view_instances')}
      </LinkButton>
    </div>
  );
};

export default DealerLocationInfo;
